/* eslint-disable react-hooks/rules-of-hooks */
import { Space, Table } from "antd";
import { FC } from "react";
import { DeleteActionSvg } from "utils/svgs";
import "./index.scss";
import { DynamicTableProps } from "./types";
import { pageSizeOptionsPaging } from "utils/constant";
import { formatDates } from "utils/utils";
import "./index.scss";

const DynamicTable: FC<DynamicTableProps> = (props) => {
  // Inits
  const { Column } = Table;
  const {
    ipDataSource,
    showModal,
    setEditSelectedUser,
    performSortHandler,
    totalRecords,
    currentPage,
    PageSize,
    modifyPageSize,
    paginationChangeHandler,
    permissions,

    isLoading,
  } = props;
  // const dispatch = useDispatch<AppDispatch>();
  // Delete user data handler
  const deleteDataHandler = (userObject: any) => {
    setEditSelectedUser(userObject);
  };
  // For handle the table change click
  const tableChangeHandler = (pageInfo: any, d: any, columnInfo: any) => {
    performSortHandler &&
      performSortHandler(columnInfo.order, pageInfo.current);
  };

  // JSX
  return (
    <div>
      {/* <SearchAndFilter
        performSearchHandler={performSearchHandler}
        searchValue={searchValue}
        performFilterHandler={performFilterHandler}
        filterValue={filterValue}
        PageSize={PageSize}
      /> */}
      <Table
        dataSource={ipDataSource}
        scroll={
          ipDataSource?.length > 10 ? { y: "calc(77vh - 133px)" } : undefined
        }
        pagination={{
          total: totalRecords,
          current: currentPage,
          onChange: paginationChangeHandler,
          pageSize: PageSize,
          pageSizeOptions: pageSizeOptionsPaging,
          showSizeChanger: true,
          onShowSizeChange: modifyPageSize,
        }}
        loading={isLoading}
        className="table-global-ip"
        onChange={tableChangeHandler}
        // style={{ minHeight: "calc(-75px + 70vh)" }}
      >
        <Column
          title="Ip Address"
          dataIndex="ipAddress"
          width={"13%"}
          key="name"
          className="bg-white"
        />

        <Column
          title="Added Date	"
          dataIndex="createdAt"
          width={"13%"}
          key="name"
          className="bg-white"
          render={(createdAt: string) => formatDates(createdAt)}
        />

        <Column
          title="Action"
          dataIndex="action"
          key="action"
          className="bg-white"
          width={"10%"}
          render={(values: any, data: any) => {
            return (
              <Space size={20}>
                {!(data?.isCompanyAdmin || data?.isAdmin) ? (
                  <>
                    {permissions?.delete ? (
                      <div
                        style={{ marginRight: "2rem" }}
                        className="cursor-pointer flex align-center justify-center"
                        onClick={() => {
                          deleteDataHandler(data);
                          showModal();
                        }}
                      >
                        <DeleteActionSvg />
                      </div>
                    ) : (
                      <div
                        style={{ marginRight: "2rem" }}
                        className={"dynamic-table__no-action"}
                      >
                        <DeleteActionSvg />
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </Space>
            );
          }}
        />
      </Table>
    </div>
  );
};

export default DynamicTable;
